import { useEffect, useState } from 'react';

// ENG-2551: where the phone-only presentation ends. Below this the background
// step lands with its category picker folded and V3Layout slims the fixed
// chrome; at or above it every surface renders exactly as it did before.
export const PHONE_MAX_WIDTH = 768;

export const isPhoneWidth = (): boolean => window.innerWidth < PHONE_MAX_WIDTH;

// Is the viewport narrow enough for the phone-only presentation? Shared with
// useFoldOnSelect so the fold and the layout decisions that depend on it can
// never disagree about where the phone ends.
//
// Reads window.innerWidth rather than matchMedia: jsdom stubs neither, and the
// specs already drive innerWidth directly, so this stays testable without a
// polyfill.
const useIsPhone = (): boolean => {
  const [isPhone, setIsPhone] = useState(isPhoneWidth);

  useEffect(() => {
    const syncWidth = () => setIsPhone(isPhoneWidth());

    // The viewport may have changed between the initial state and this effect.
    syncWidth();

    window.addEventListener('resize', syncWidth);
    return () => window.removeEventListener('resize', syncWidth);
  }, []);

  return isPhone;
};

export default useIsPhone;
